// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__Id2WX","navigation-item":"styles_navigation-item__xENn9","active":"styles_active__SkIlZ"};